import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { api } from '@/lib/api';
import { errorMessage } from '@/components/Toast';
import { Button, Field, Input } from '@/components/ui';
import { AuthAside } from './AuthAside';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api.auth.forgotPassword(email.trim());
      setSent(true);
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth">
      <AuthAside />
      <div className="auth-main">
        <div className="auth-card">
          <p className="eyebrow">Account recovery</p>
          <h1 >Reset your password</h1>

          {sent ? (
            // Deliberately identical whether or not the address exists — no enumeration.
            <p>If an account exists for that address, a reset link is on its way.</p>
          ) : (
            <form className="stack gap-4" onSubmit={onSubmit}>
              <Field label="Email" hint="We'll email you a link to choose a new password." error={error ?? undefined}>
                <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="email" placeholder="you@firm.com" required autoFocus />
              </Field>
              <Button type="submit" className="block" loading={busy}>Send reset link</Button>
            </form>
          )}

          <p className="muted mt-5 t-sm">
            Remembered it? <Link to="/login" className="inline-link">Back to sign in</Link>.
          </p>
        </div>
      </div>
    </div>
  );
}
